import { render, staticRenderFns } from "./DanhMucTinTucForm.vue?vue&type=template&id=2e5cefe8&"
import script from "./DanhMucTinTucForm.vue?vue&type=script&lang=js&"
export * from "./DanhMucTinTucForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports